import PropTypes from "prop-types"
import React, { Component } from "react"
import { PoseGroup } from "react-pose"
import { connect } from "react-redux"
import { Link } from "react-router-dom"
import { bindActionCreators } from "redux"

import { t, tError } from "../../i18next"
import LhoBuildingIcon from "../../images/icons/lho_building-104.png"
import { Drilldown, DrilldownList, DrilldownItem } from "../common"
import { nearest, formatDistance } from "../common/locationSupport"
import { cityLabelFor } from "../common/presentationFormatters"
import * as actions from "./redux/actions"

export class PropertiesDrilldown extends Component {
  static propTypes = {
    home: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  }

  render() {
    const { fetchAllLgError, fetchAllLgPending, lhoData } = this.props.home

    if (lhoData && lhoData.properties.length > 0) {
      return this.renderData(lhoData)
    } else if (fetchAllLgError) {
      return this.renderError(fetchAllLgError)
    } else if (fetchAllLgPending) {
      return this.renderPending()
    } else {
      return this.renderNoData()
    }
  }

  renderPending() {
    return (
      <Drilldown className="home-properties-drilldown" title={t("home.nearbyProperties")}>
        <div className="message">{t("home.fetchingLho")}</div>
      </Drilldown>
    )
  }

  renderError({ networkError, graphqlErrors }) {
    return (
      <Drilldown className="home-properties-drilldown" title={t("home.nearbyProperties")}>
        <div className="message">
          {networkError && <div>{tError("home", networkError)}</div>}
          {graphqlErrors && <div>{tError("home", graphqlErrors)}</div>}
        </div>
      </Drilldown>
    )
  }

  renderData(lhoData) {
    return (
      <Drilldown className="home-properties-drilldown" title={t("home.nearbyProperties")}>
        <DrilldownList>
          <PoseGroup flipMove={true}>
            {nearest(30, lhoData.properties).map(property => (
              <DrilldownItem key={property.reference}>
                <Link to={`/lho/${property.reference}`}>
                  <div className="icon-container">
                    <div className="icon">
                      <img className="icon-property" alt="LG" src={LhoBuildingIcon} />
                    </div>
                    <div className="distance">{formatDistance(property.distance)}</div>
                  </div>
                  <div className="info">
                    <div className="reference">{property.reference}</div>
                    <div className="description">{property.description}</div>
                    <div className="city">{cityLabelFor(property)}</div>
                  </div>
                </Link>
              </DrilldownItem>
            ))}
          </PoseGroup>
        </DrilldownList>
      </Drilldown>
    )
  }

  renderNoData() {
    return (
      <Drilldown className="home-properties-drilldown" title={t("home.nearbyProperties")}>
        <div>{t("home.noProperties")}</div>
      </Drilldown>
    )
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    home: state.home,
  }
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PropertiesDrilldown)



// WEBPACK FOOTER //
// ./src/features/home/PropertiesDrilldown.js